import loginActionTypes from "./login.types";
import { docodeHexResponse } from "../_common/common.utils";

const INITIAL_STATE: any = {
  loginResponse: null,
  loginDateTime: null,
  authCheckDone: 0,
  loginDeocodedResponse: [],
  userAuthVerifyResponse: null,
  currencySymbols: "",
  forgotPasswordResponse: null,
  forgotPasswordDeocodedResponse: null,
  updateUserPasswordStatus: null,
  updateUserPasswordResponse: [],
  getUserLoginDetailsResponse: null,
  getUserLoginDetailsArr: [],
  totpPendingResponse: null,
  totpPendingDecoded: [],
};

const loginReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /***************  USER LOGIN START  ******************/
    case loginActionTypes.USER_SIGN_IN_SUCCESS:
      return {
        ...state,
        loginResponse: action.payload,
        loginDeocodedResponse: docodeHexResponse(
          action.payload,
          "UserLoginVerify",
        ),
        totpPendingResponse: null,
        totpPendingDecoded: [],
      };

    case loginActionTypes.USER_TOTP_REQUIRED:
      return {
        ...state,
        totpPendingResponse: action.payload,
        totpPendingDecoded: docodeHexResponse(
          action.payload,
          "UserLoginVerify",
        ),
      };

    case loginActionTypes.USER_TOTP_RESET:
      return {
        ...state,
        totpPendingResponse: null,
        totpPendingDecoded: [],
      };

    // Live RBAC refresh: patch userAccessData on the persisted login object so
    // the sidebar, route guard and CRUD gating pick up grant changes without a
    // full re-login. Only touches userAccessData; everything else is untouched.
    case loginActionTypes.UPDATE_USER_ACCESS_DATA: {
      const arr = Array.isArray(state.loginDeocodedResponse)
        ? [...state.loginDeocodedResponse]
        : [];
      if (arr.length === 0) return state;
      arr[0] = { ...arr[0], userAccessData: action.payload ?? [] };
      return { ...state, loginDeocodedResponse: arr };
    }

    case loginActionTypes.USER_SIGN_IN_FAILURE:
      return {
        ...state,
        loginResponse: action.payload,
        loginDeocodedResponse: docodeHexResponse(
          action.payload,
          "UserLoginVerify",
        ),
      };

    case loginActionTypes.USER_SIGN_IN_RESPONSE_CHANGED:
      return {
        ...state,
        loginResponse: null,
      };

    case loginActionTypes.USER_SIGN_OUT:
      return {
        ...state,
        authCheckDone: 0,
        loginDateTime: null,
        loginResponse: null,
        loginDeocodedResponse: [],
      };

    case loginActionTypes.USER_AUTH_CHECK_DONE_CHANGED:
      return {
        ...state,
        authCheckDone: action.payload,
      };

    case loginActionTypes.USER_LOGIN_TIME_CHANGED:
      return {
        ...state,
        loginDateTime: action.payload,
      };
    /***************  USER LOGIN END  ******************/

    /*****************  USER AUTH VERIFY START  *******************/
    case loginActionTypes.USER_AUTH_VERIFY_SUCCESS:
      return {
        ...state,
        userAuthVerifyResponse: action.payload,
      };

    case loginActionTypes.USER_AUTH_VERIFY_FAILURE:
      return {
        ...state,
        userAuthVerifyResponse: action.payload,
      };

    case loginActionTypes.USER_AUTH_VERIFY_RESPONSE_CHANGED:
      return {
        ...state,
        userAuthVerifyResponse: null,
      };

    /***************** 	USER AUTH VERIFY END  *****************/

    /*****************  FORGOT PASSWORD START  *******************/
    case loginActionTypes.FETCH_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPasswordResponse: action.payload,
        forgotPasswordDeocodedResponse: docodeHexResponse(
          action.payload,
          "ForgotPassKey",
        ),
      };

    case loginActionTypes.FETCH_FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPasswordResponse: action.payload,
        forgotPasswordDeocodedResponse: docodeHexResponse(
          action.payload,
          "ForgotPassKey",
        ),
      };

    case loginActionTypes.FETCH_FORGOT_PASSWORD_RESPONSE_CHANGED:
      return {
        ...state,
        forgotPasswordResponse: null,
        forgotPasswordDeocodedResponse: null,
      };

    /***************** 	FORGOT PASSWORD END  *****************/

    /*****************  UPDATE LOGIN USER PASSWORD START  *******************/
    case loginActionTypes.UPDATE_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        updateUserPasswordStatus: action.payload,
        updateUserPasswordResponse: docodeHexResponse(
          action.payload,
          "UPDATEUSERPASSWORDKEY",
        ),
      };

    case loginActionTypes.UPDATE_USER_PASSWORD_FAILURE:
      return {
        ...state,
        updateUserPasswordStatus: action.payload,
      };

    case loginActionTypes.UPDATE_USER_PASSWORD_RESPONSE_CHANGED:
      return {
        ...state,
        updateUserPasswordStatus: null,
      };

    /***************** 	UPDATE LOGIN USER PASSWORD END  *****************/
    /** ***************** GET USER COMPANY DETAILS START *********************** */
    case loginActionTypes.FETCH_USER_COMPANY_DETAILS_SUCCESS:
      return {
        ...state,
        getUserLoginDetailsResponse: action.payload,
        getUserLoginDetailsArr: docodeHexResponse(
          action.payload,
          "GetUserCompanyDetailsKey",
        ),
      };

    case loginActionTypes.FETCH_USER_COMPANY_DETAILS_FAILURE:
      return { ...state, getUserLoginDetailsResponse: action.payload };

    case loginActionTypes.FETCH_USER_COMPANY_DETAILS_RESPONSE_CHANGED:
      return { ...state, getUserLoginDetailsResponse: null };

    /** ***************** GET USER COMPANY DETAILS END *********************** */
    default:
      return state;
  }
};

export default loginReducer;
